<template>
    <div class="common-layout" style="height: 100vh; overflow: hidden;" v-if="$route.meta.showNav">
        <el-container :class="[{'back_img': !userType}, { 'no-bg': userType}]">
            <el-aside class="scrollbar-hidden" width="200px" style="height: 100vh;">
                <Aside v-if="userType"/>
                <a v-if="!userType" href="/">
                    <el-row
                        style="border-right: 1px solid rgb(220, 223, 230); border-bottom: 1px solid rgb(220, 223, 230);">
                        <el-col :span="9" style="text-align: center;">
                            <img style="width: 40px; padding: 9px 0 5px 30px;" src="@/assets/images/logo.png"
                                 alt="课立方">
                        </el-col>
                        <el-col :span="15">
                            <el-text
                                style="font-size: 25px; line-height: 58px; color: black; font-family: '钉钉进步体';">课立方
                            </el-text>
                        </el-col>
                    </el-row>
                </a>
            </el-aside>
            <el-container>
                <el-header style="height: 58px; position: relative;">
                    <Header style="border-bottom: 1px solid rgb(220, 223, 230); width: 100%;"/>
                </el-header>
                <el-main id="main-container" style="padding: 10px; height: calc(100vh - 58px); overflow: auto;">
                    <router-view v-if="userType"/>
                    <div v-if="!userType" id="introduction">
                        <el-text
                            style="font-size: 60px; line-height: 58px; color: #007dff; font-family: '钉钉进步体'; font-weight: bold;">
                            课立方
                        </el-text>
                        <br><br><br>
                        <el-text id="introduction-text"
                                 style="font-size: 40px; line-height: 58px; color: black;">{{ introduction_text }}
                        </el-text>
                    </div>
                </el-main>
                <el-backtop v-if="userType" target="#main-container" :visibility-height="100">
                    <to-top theme="outline" size="30" fill="#fff" :strokeWidth="3"/>
                </el-backtop>
            </el-container>
        </el-container>
    </div>
    <router-view v-if="!$route.meta.showNav"/>
</template>

<style scoped>
.el-header {
    --el-header-padding: 0;
}

.el-main {
    --el-main-padding: 0;
}

.back_img {
    background-image: url("~@/assets/images/bj.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center 58px;
}

#introduction {
    width: 80vw;
    text-align: center;
    position: absolute;
    left: 10vw;
    top: 50vh;
    transform: translateY(-50%);
    margin: auto;
}

:deep(.el-backtop) {
    width: 45px;
    height: 45px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.5);
}

:deep(.el-backtop:hover) {
    background-color: rgba(0, 0, 0, 0.8);
    transition: background-color 0.2s;
}
</style>
<script>
import Aside from "@/components/Aside.vue";
import Header from "@/components/Header.vue";
import {ToTop} from "@icon-park/vue-next";

export default {
    name: 'App',
    components: {
        Aside,
        Header,
        ToTop,
    },
    data() {
        return {
            userType: "",
            introduction_text: "",
        };
    },
    created() {
        this.userType = localStorage.getItem("userType");
        if (!this.userType) {
            this.typing();
        }
    },
    updated() {
        this.userType = localStorage.getItem("userType");
        if (!this.userType) {
            this.typing();
        }
    },
    methods: {
        typing() {
            let i = 0;
            let str = "把黑板装进口袋，让讲台住在云端";
            const typeWriter = () => {
                if (i <= str.length) {
                    this.introduction_text = str.slice(0, i++) + '█';
                    setTimeout(typeWriter, 250);
                } else {
                    this.introduction_text = str;
                }
            };
            typeWriter();
        },
    },
};
</script>